<div class="flex justify-between items-center mb-4">
  <h2 class="text-xl font-semibold">User Management</h2>
  <app-button size="sm" (click)="loadUsers()">Refresh</app-button>
</div>

<!-- Loading Spinner -->
<div *ngIf="isLoading" class="flex justify-center items-center py-20">
  <div class="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
</div>

<!-- Error State -->
<div *ngIf="!isLoading && errorMessage"
  class="flex items-center gap-3 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
  <span>{{ errorMessage }}</span>
  <button (click)="loadUsers()" class="ml-auto text-sm underline">Retry</button>
</div>

<app-data-table 
  *ngIf="!isLoading && !errorMessage"
  title="Users Table" 
  [data]="users" 
  [columns]="columns">
</app-data-table>

<!-- ACTION TEMPLATE -->
<ng-template #actionTemplate let-user>
  <div class="flex items-center gap-3">
    <!-- Edit Role -->
    <button (click)="openEditModal(user)" class="text-gray-500 hover:text-blue-600 transition" title="Edit Role">
      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
      </svg>
    </button>
    
    <!-- Block / Unblock -->
    <button
      (click)="toggleBlock(user)"
      class="text-gray-500 transition"
      [class.hover:text-red-600]="user.status === 'Active'"
      [class.hover:text-emerald-600]="user.status !== 'Active'"
      [title]="user.status === 'Active' ? 'Suspend' : 'Activate'">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" />
        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
      </svg>
    </button>
  </div>
</ng-template>

<app-modal [isOpen]="isModalOpen" (close)="isModalOpen = false" className="max-w-2xl">
  <app-role-form [user]="selectedUser" (save)="handleSave($event)" (cancel)="isModalOpen = false">
  </app-role-form>
</app-modal>